import { render, staticRenderFns } from "./DraggableBottons.vue?vue&type=template&id=74db276b&"
import script from "./DraggableBottons.vue?vue&type=script&lang=js&"
export * from "./DraggableBottons.vue?vue&type=script&lang=js&"
import style0 from "./DraggableBottons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports